module.exports = __webpack_public_path__ + "img/0.26d5715d.jpg";